import React from "react";
import { Icons } from "@learningblocks/exp-constants";
import PropTypes from "prop-types";

const { IconStart } = Icons;

const OPEN_ICON_STYLE = {
  transform: "rotate(90deg)",
};
const CLOSE_ICON_STYLE = {
  transform: "rotate(-90deg)",
};

/**
 * IconOpen :
 *  - Icon to click when you want to open dropdown
 */
export function IconOpen(props) {
  return <IconStart className={props.className} style={OPEN_ICON_STYLE} />;
}

/**
 * IconClose:
 *  - Icon to click when you want to close dropdown.
 */
export function IconClose(props) {
  return <IconStart className={props.className} style={CLOSE_ICON_STYLE} />;
}

const IconPropsTypes = {
  /**
   * ClassName to be set on the icon
   */
  className: PropTypes.string,
};

IconOpen.propTypes = IconPropsTypes;
IconClose.propTypes = IconPropsTypes;
